let modalsOpened = [];

$('body').on('show.bs.modal', '.modal', function() {
    let modalInstance = bootstrap.Modal.getInstance(this);

    const setZIndex = (el) => {
        if(modalInstance._backdrop._element !== null) {
            let modal = $(el);

            modal.css('z-index', 1060 + modalsOpened.length * 10 + 2)
            $(modalInstance._backdrop._element).css('z-index', 1060 + modalsOpened.length * 10 + 1)

            modalsOpened = [...modalsOpened, modal];
        } else {
            setTimeout(() => {
                setZIndex(el)
            }, 50)
        }
    }

    setZIndex(this);
}).on('hide.bs.modal', function() {
    let modal = $(this);
    modalsOpened = modalsOpened.filter(m => m.attr('id') !== modal.attr('id'));
})
